import { jsxs, jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
import { internalTokens } from "./themes2.js";
function ListItem({
  children,
  subtext,
  thumbnail,
  rightElements,
  ...props
}) {
  return /* @__PURE__ */ jsxs(ItemStyled, {
    ...props,
    children: [thumbnail && /* @__PURE__ */ jsx(ThumbnailContainer, {
      children: thumbnail
    }), /* @__PURE__ */ jsxs(Content, {
      children: [children, subtext ? /* @__PURE__ */ jsx(Subtext, {
        children: subtext
      }) : null]
    }), rightElements]
  });
}
const ItemStyled = styled.div.withConfig({
  displayName: "ItemStyled",
  componentId: "sc-shh96p-0"
})(["display:flex;gap:", ";align-items:center;margin-inline:calc(", " * -1);padding:", " ", ";"], token.spacing3, token.spacing5, token.spacing3, token.spacing5);
const ThumbnailContainer = styled.div.withConfig({
  displayName: "ThumbnailContainer",
  componentId: "sc-shh96p-1"
})(["flex:none;"]);
const Content = styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-shh96p-2"
})(["", " flex:1;min-width:0;"], textStyles.uiTextM);
const Subtext = styled.div.withConfig({
  displayName: "Subtext",
  componentId: "sc-shh96p-3"
})(["", " color:", ";"], textStyles.uiTextS, internalTokens["tooltip-secondary-text-color"]);
export {
  ListItem
};
//# sourceMappingURL=ListItem4.js.map
